<template>
    <v-layout class="left-aligned scrollactive-item-container" :class="{disabled: isDisabled}">
        <span class="scrollactive-item" v-if="isDisabled">{{ index+1 }}</span>
        <a v-else class="scrollactive-item" :href="'#Q'+ (index+1)" :v-model="panel" @click="isSurveyLocked==null && onNavPanelClicked(index)" :class="{active: isActive}">
            {{ index+1 }}
            <question-status-icon :questionId="question.id"></question-status-icon>
        </a>
    </v-layout>
</template>

<script>
import { surveyService } from '@/services/surveyService';
import { authTokenService } from '@/services/authTokenService.js';

export default {
  name: 'Survey',
  props: {
    question: Object,
    index: Number,
    isActive: Boolean,
    panel: Array,
    isDisabled: Boolean,
    isSurveyLocked: null,
    isLocked: null
  },
  mounted () {
      const activeSurveyId = authTokenService.getActiveSurveyId();
      //me.getSurveyLocked(activeSurveyId); //not in use for time being.. cmmented on 11/08/2022, due to throwing errors at Q loads.
    },
  methods: {
      onNavPanelClicked () {
        this.$emit('side-nav-question-clicked', { idx: this.index });
      },
      getSurveyLocked (activeSurveyId) {
        const me = this;
        surveyService.getLockStatus(activeSurveyId).then(function (response) {
          if (response && response.data != null) {
            if (response.data.isLocked == true) {
                me.isLocked = true;
                me.isSurveyLocked = "isDisabled";
            } else if (response.data.currentUser != null) {
              me.isLocked = true;
            } else {
              me.isLocked = false;
			        me.isSurveyLocked = null;
            }
          }
        })
        .catch(function (e) {
          console.log(e);
          console.log('Error loading survey lock status')
          throw e;
        });
      }
  }
}
</script>

<style scoped>

div.scrollactive-item-container a.scrollactive-item {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.scrollactive-item {
  list-style-type: none;
  margin-left: 0px;
  padding-left: 10px;
  width: 100%;
  color: white;
  font-weight: normal;
  font-size: 12pt;
  align-items: center;
}

span.scrollactive-item {
    background-color: dimgray;
    padding-left: 18px;
}

.scrollactive-nav .layout.disabled {
  border-bottom: 1px solid gray;
}

.status-container {
  width: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

button .status-container {
  height: 25px;
  margin-right: 5px;
}

a.scrollactive-item:hover {
  color: #fff;
  text-decoration: none;
  background-color: #1b639b;
}
.active > .scrollactive-item {
  background-color: #5b9bd5;
}
.active:hover {
  color: white;
  text-decoration: none;
  background-color: #2f76b7;
}
.scrollactive-item-container:hover {
  background-color: #2f76b7;
}
.scrollactive-nav .layout {
  background-color: #0f5182;
  border-bottom: 1px solid #12629e;
}
.scrollactive-item-container.active {
  background-color: #5b9bd5;
}
.left-aligned {
 text-align: left;
}

section{
  height: 100vh;
  position:relative;
  margin: 0;
  padding: 0;
  display:block;
  z-index: 0;
}
.section-reference {
   text-align: left;
}
.section-reference:hover {
    background-color: #2f76b7;
}
.section-reference .scrollactive-item {
  font-size: 9pt;
  font-style: italic;
  width: 100%;
  text-align: center;
  padding-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.content-header {
    font-size: 11px;
    background-color: black;
    color: white;
    padding-top: 1px;
    padding-bottom: 1px;
}
.status-img {
  width: 22px;
  height: 24px;
}
.green {
    color: green !important;
    background-color: white !important;
}
.status-icon.active.green {
  color: green !important;
  background-color: white !important;
}
.orange {
  color: orangered;
}

.accordion-status-icon,
.accordion-status-img {
    margin-left: 10px;
    margin-right: 10px;
}
.accordion-status-img {
    width: 20px;
    height: 20px;
}
</style>
